import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  jobpositionRelated: null,
  jobpositionRelatedError: "",
  formError: "",
};

export default function JobpositionRelatedReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_JOB_POSITION_RELATED:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_JOB_POSITION_RELATED:
      return { ...state, saveLoading: action.payload };
    case actions.GET_JOB_POSITION_RELATED:
      return { ...state, jobpositionRelated: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.JOB_POSITION_RELATED_FAIL:
      return { ...state, jobpositionRelatedError: action.payload };
    default:
      return state;
  }
}
